// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "global." + {"301":"d6985b6619c9b168119b","792":"39259dc0862d70c832f4"}[chunkId] + ".js";
};